
import {getProductByID, toPlantation } from '../shop-front-component/ProductCollection'

import GenericProductPage from './GenericProductPage'

export default function TimberPlantationShutterPage() {

  return (
      GenericProductPage(getProductByID(44),toPlantation)
  )
}
